<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Edit dosage type">
      <p class="mt-2">{{data.message}}</p>
      <button mat-flat-button color="primary" *authGroup="['SuperAdmin']" class="my-2" (click)="editMode = !editMode">
        {{editMode ? 'Details' : 'Edit'}}
      </button>
      @if (!editMode && medicineDosageType) {
        <div class="details">
          <table>
            <tr>
              <th>Name</th>
              <td>{{medicineDosageType.additional_information ? data.medicineDosageType.additional_information :
              "-"}}</td>
            </tr>
            <tr>
              <th>Type</th>
              <td>{{getDosageType(medicineDosageType)}}</td>
            </tr>
            <tr>
              <th>Usage instructions</th>
              <td>{{medicineDosageType.usage_instructions ? medicineDosageType.usage_instructions : "-"}}
              </td>
            </tr>
            <tr>
              <th>Storage directions</th>
              <td>
                {{medicineDosageType.storage_directions ? medicineDosageType.storage_directions : "-"}}
              </td>
            </tr>
            <tr>
              <th>Special instructions</th>
              <td>
                {{medicineDosageType.special_instructions ? medicineDosageType.special_instructions :
                "-"}}
              </td>
            </tr>
            <tr>
              <th>Dosage strength</th>
              <td>
                {{medicineDosageType.dosage_strength ? medicineDosageType.dosage_strength : "-"}}
              </td>
            </tr>
          </table>
        </div>
      }
      @if (editMode) {
        <form autocomplete="off" [formGroup]="medicineDosageTypeForm">
          <div class="row">
            <p class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <mat-select required formControlName="dosageType">
                  @for (type of dosageTypes; track type) {
                    <mat-option class="d-flex" [value]="type">
                      {{type.type}}
                    </mat-option>
                  }
                </mat-select>
                <button type="button" matSuffix mat-icon-button (click)="createDosageType($event)">
                  <mat-icon>add</mat-icon>
                </button>
                @if (medicineDosageTypeForm.get('dosageType')?.invalid) {
                  <mat-error>
                    Dosage type is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input required type="text" formControlName="additionalInformation" matInput placeholder="Name">
                @if (medicineDosageTypeForm.get('additionalInformation')?.invalid) {
                  <mat-error>
                    Name is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Active</mat-label>
                <mat-select formControlName="isActive">
                  <mat-option value="true">Yes</mat-option>
                  <mat-option value="false">No</mat-option>
                </mat-select>
                @if (medicineDosageTypeForm.get('isActive')?.invalid) {
                  <mat-error>
                    Active is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Strength</mat-label>
                <input required formControlName="dosageStrength" type="text" matInput placeholder="Strength">
                @if (medicineDosageTypeForm.get('dosageStrength')?.invalid) {
                  <mat-error>
                    Strength is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
          </div>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Usage instructions</mat-label>
              <textarea required formControlName="usageInstructions" matInput
              placeholder="Usage instructions"></textarea>
              @if (medicineDosageTypeForm.get('usageInstructions')?.invalid) {
                <mat-error>
                  Usage instructions is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Storage directions</mat-label>
              <textarea required formControlName="storageDirections" matInput
              placeholder="Storage directions"></textarea>
              @if (medicineDosageTypeForm.get('storageDirections')?.invalid) {
                <mat-error>
                  Storage directions is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Special instructions</mat-label>
              <textarea required formControlName="specialInstructions" matInput
              placeholder="Special instructions"></textarea>
              @if (medicineDosageTypeForm.get('specialInstructions')?.invalid) {
                <mat-error>
                  Special instructions is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
          <div class="my-2 text-end">
            <button [disabled]="!medicineDosageTypeForm.valid" type="button" mat-raised-button color="primary"
            (click)="save()">Save</button>
          </div>
        </form>
      }
      <mat-divider></mat-divider>
      <div class="mt-2">
        <h4>Package types</h4>
        @if (!perm.isViewer()) {
          <mat-tab-group>
            <mat-tab label="Create">
              <form class="mt-2" [formGroup]="medicineDosagePackageTypeForm">
                <div class="row">
                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Label name</mat-label>
                      <input required formControlName="labelName" placeholder="Label name" type="text" matInput>
                      @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
                        <mat-error>
                          Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
                        </mat-error>
                      }
                      <mat-hint>Maximum of 25 characters</mat-hint>
                    </mat-form-field>
                  </p>
                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Price</mat-label>
                      <input required formControlName="price" placeholder="Price" type="number" matInput>
                      @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
                        <mat-error>
                          Price is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Package Type</mat-label>
                      <mat-select required formControlName="packageType">
                        @for (type of packageTypes; track type) {
                          <mat-option [value]="type">
                            {{type.type}}
                          </mat-option>
                        }
                      </mat-select>
                      <button type="button" matSuffix mat-icon-button (click)="createPackageType($event)">
                        <mat-icon>add</mat-icon>
                      </button>
                      @if (medicineDosagePackageTypeForm.get('packageType')?.invalid) {
                        <mat-error>
                          Package type is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Quantity</mat-label>
                      <input required formControlName="containedQuantity" placeholder="Quantity" type="number"
                        matInput>
                      <span matSuffix>{{currentDosageUnit ? currentDosageUnit.unit : "-"}}</span>
                      @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
                        <mat-error>
                          Quantity is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                </div>
              </form>
              <button mat-stroked-button [disabled]="!medicineDosagePackageTypeForm.valid"
                (click)="createMedicineDosagePackageType()">
                <mat-icon>add</mat-icon> Add package type
              </button>
              <!--List out the package types :)-->
              @if (data.medicineDosageType) {
                <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
                  [medicineDosageTypeId]="data.medicineDosageType.id"
                  [packageTypes]="packageTypes" [medicineId]="data.medicineId"
                  [medicineDosagePackageTypes]="medicineDosagePackageTypes">
                </core-medicine-dosage-package-type-list>
              }
            </mat-tab>
            <mat-tab label="Manage units">
              @for (type of dosageTypes; track type) {
                <div class="mt-2">
                  <div class="row">
                    <p class="col-md-8">{{type.type}}</p>
                    <p class="col-md-4 text-end">
                      <button (click)="deleteDosageType(type)" mat-flat-button color="warn">Delete</button>
                    </p>
                  </div>
                  <div class="py-2">
                    <mat-divider></mat-divider>
                  </div>
                </div>
              }
            </mat-tab>
          </mat-tab-group>
        } @else {
          @if (data.medicineDosageType) {
            <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
              [medicineDosageTypeId]="data.medicineDosageType.id"
              [packageTypes]="packageTypes" [medicineId]="data.medicineId"
              [medicineDosagePackageTypes]="medicineDosagePackageTypes">
            </core-medicine-dosage-package-type-list>
          }
        }
      </div>
    </mat-tab>
    <mat-tab label="Manage dosages">
      @for (type of dosageTypes; track type) {
        <div class="mt-2">
          <div class="row">
            <p class="col-md-8">{{type.type}}</p>
            <p class="col-md-4 text-end">
              <button (click)="deleteDosageType(type)" mat-flat-button color="warn">Delete</button>
            </p>
          </div>
          <div class="py-2">
            <mat-divider></mat-divider>
          </div>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button [disabled]="!medicineDosageTypeForm.valid || !data.medicineDosageType || valuesChanged" mat-raised-button color="primary"
    (click)="closeDialog()">
    <mat-icon>done</mat-icon> Done
  </button>
</div>